import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * PaymentReturnScreen - Handles redirect from BSE Payment Gateway
 * Redirects to Payment Status Screen with order details
 */
export default function PaymentReturnScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const clientCode = searchParams.get("ClientCode") || searchParams.get("clientCode");
    const orderNo = searchParams.get("OrderNo") || searchParams.get("orderNo");

    if (clientCode && orderNo) {
      navigate("/payment/status", {
        replace: true,
        state: { orderNo, clientCode },
      });
    } else {
      navigate("/payment/status", { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content p-4">
          <div className="text-center py-5">
            <span className="spinner-border spinner-border-lg text-primary mb-3" role="status" />
            <p>Redirecting to payment status...</p>
          </div>
        </div>
      </div>
    </div>
  );
}
